export default __webpack_public_path__ + "static/media/mini-plumbapp-logo.977e2d8d.svg";